ContactsHandler = App.loadClass "grower::handlers/contacts/Contacts_Handler"
ScrollHelper = App.load "core::ScrollHelper"

class exports.Invite_Tab_Handler extends ContactsHandler
    init: () ->
        @layoutUrl = "backend/grower/contacts/invitetab/load-layout"
        @layoutSelector = "#contactstab_invite"

        msgwriter = App.sidebar.messageWriter()
        msgwriter.message_writer()
        msgwriter.message_writer('info', 'Loading...')

        @loadLayout()

    afterLoadLayout: (selector, data) ->

        ths = this

        laySel = @layoutSelector
        $(laySel).find('.txt-search').focus()
        ###
            Can I change the layoutUrl dynamically and so change which views, etc are being used and stuff thus making better code?
        ###


        ## Trigger Search On Enter Press ##
        $(@layoutSelector).find('.txt-search').keypress( (event) ->
            if( event.which is 13 )
                $(laySel).find('.btn-search').click()
        )

        ## Set Search Btn Event Listener ##
        $(@layoutSelector).find('.btn-search').click( (e) ->
            search = $(laySel).find('.txt-search')
            if( search.val() )
                tableDiv = $(laySel).find('.table-div')
                tableDiv.removeClass('example')
                tableDiv.empty().append("<text class='saving'>Searching...</text>")

                $.post(
                    'backend/grower/contacts/invitetab/get-searchresults-ajax'
                    { 'search_text': search.val() },
                    (json) ->
                        if(json.status.type is 'success')

                            tableDiv.empty().append(json.data)



                            ## Set Tooltip on Blocked Users ##
                            $('.blocked-user').tooltip(true, 'top', false, 'Blocked User', 'hover', 0)

                            ## Set up Listeners on the Permission DDMs ##
                            $(tableDiv).find('.sel-permission').change(
                                { 'ths': ths },
                                ths.permissionListener
                            )

                            ths.pgSetup(selector)
                        else

                            #alert("ERROR: did not correctly search.   Technical Details--> (#{json.status.type}, #{json.status.msg})")
                            App.current_page.refreshSubHandlers()   #not sure if I want to keep this...

                )
            else
                if( not $(laySel).find('.example-table-div').length > 0 )
                    App.current_page.refreshSubHandlers()
                )

        @tabLoadLayoutCallback(selector, data)





    pgSetup: (selector, data) ->
        ths = this


        ## Set Event Listeners For Permission DDM ##
        $(@layoutSelector).find('#addpermission').click( (e) ->
            e.preventDefault()
            handler = $(this).data('handler')
            sub = ths.createSubHandler(handler)
            if sub
                sub.init()
        )
        $(@layoutSelector).find('#editpermission').click( (e) ->
            e.preventDefault()
            handler = $(this).data('handler')
            sub = ths.createSubHandler(handler)
            if sub
                sub.init()
        )
        $(@layoutSelector).find('#removepermission').click( (e) ->
            e.preventDefault()
            handler = $(this).data('handler')
            sub = ths.createSubHandler(handler)
            if sub
                sub.init()
        )
        ## make the table scrollable ##
        App.sidebar.contentDiv().find(".tab-content").resizr()
        table = $(selector).find(".list-table")
        $(selector).find(".table-container").resizr()
        ScrollHelper.make table,
            height: $(selector).find(".table-container").resizr 'size'


        table.find('tbody tr .row-clickable').bind 'click', (e) ->
            table.find('tr').removeClass('darken')
            ths.viewUserS e, $(this), selector

    permissionListener: (event) ->
        ths = event.data.ths

        sel = $(this)

        tr = sel.parents('tr')
        original = tr.html()

        contact_id = sel.data('contact_id')
        permission_id = sel.val()

        sel.replaceWith('<text class="saving">Saving...</text>')

        if( sel.data('blocked') )
            requestVars = {
                'contact_id': contact_id,
                'permission_id': permission_id,
                'blocked': true
            }
            undoVars = {
                'tr': tr,
                'original': original,
                'ths': ths,
                'blocked': true
            }
        else
            requestVars = {
                'contact_id': contact_id,
                'permission_id': permission_id,
            }
            undoVars = {
                'tr': tr,
                'original': original,
                'ths': ths,
                'blocked': false
            }

        $.post(
            'backend/grower/contacts/invitetab/requestcontact-ajax',
            requestVars,
            (json) ->
                if(json.status.type is 'success')
                    #alert("Note, select changes to saving, while saving.\n (Comment out to see how fast this happens)")         #TAKE OUT !!!
                    tr.tooltip('disable')
                    confirmed = "<text class='contact_success'>Request Sent!</text>"
                    undo = "<a class='a-undo' data-contact_id=#{contact_id} data-permission_id=#{permission_id}>(Undo)</a>"
                    tr.empty().append("<td colspan='3'> #{confirmed} &nbsp;&nbsp;&nbsp;&nbsp; #{undo} </td>")
                    tr.find('.a-undo').bind(
                        "click",
                        undoVars,
                        ths.undoListener
                    )
                else
                    #alert("ERROR: could not send contact request.   Technical Details-->(#{json.status.type}, #{json.status.msg})")
                    App.current_page.refreshSubHandlers()
        )




    undoListener: (event) ->
        ths = event.data.ths
        tr = event.data.tr
        original = event.data.original
        blocked = event.data.blocked

        event.preventDefault()
        a = $(this)
        contact_id = a.data('contact_id')
        permission_id = a.data('permission_id')

        if(blocked)
            undoVars = {
                'contact_id': contact_id,
                'permission_id': permission_id,
                'blocked': true
            }
        else
            undoVars = {
                'contact_id': contact_id,
                'permission_id': permission_id,
            }

        $.post(
            'backend/grower/contacts/invitetab/undorequest-ajax',
            undoVars,
            (json) ->
                if(json.status.type is 'success')
                    #alert("Note, select changes to saving, while saving.\n (Comment out to see how fast this happens)")
                    tr.empty().append(original)

                    ## Bind Tooltip Event ##
                    #I Cannot figure out how to do this...

                    ## Bind Permissions Select Listener ##
                    tr.find('.sel-permission').bind(
                        "change",
                        { 'ths': ths },
                        ths.permissionListener
                    )
                else
                    #alert("ERROR: could not confirm contact.   Technical Details-->(#{json.status.type}, #{json.status.msg})")
                    App.current_page.refreshSubHandlers()
        )
